import { render } from "./SimplifiedCriterion.vue?vue&type=template&id=b1cddfaa&scoped=true"
import script from "./SimplifiedCriterion.vue?vue&type=script&lang=js"
export * from "./SimplifiedCriterion.vue?vue&type=script&lang=js"

import "./SimplifiedCriterion.vue?vue&type=style&index=0&id=b1cddfaa&scoped=true&lang=css"
import "./SimplifiedCriterion.vue?vue&type=style&index=1&id=b1cddfaa&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1cddfaa"]])

export default __exports__